import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminRoutingModule } from './admin-routing.module';
import { PageEditorComponent } from './page-editor/page-editor.component';
import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxEditorModule } from 'ngx-editor';
import { ReactiveFormsModule } from '@angular/forms';
import { FrontPageComponent } from './front-page/front-page.component';
import { EventsComponent } from 'src/app/component/events/events.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MenuEditorComponent } from './menu-editor/menu-editor.component';
import { ToastrModule } from 'ngx-toastr';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { AffiliateComponent } from 'src/app/component/affiliate/affiliate.component';
import { EventsFormComponent } from 'src/app/component/events-form/events-form.component';
import { AffiliatesFormComponent } from 'src/app/component/affiliates-form/affiliates-form.component';
import { ProfileComponent } from './profile/profile.component';
import { NgbDatepickerModule, NgbTimepickerModule} from '@ng-bootstrap/ng-bootstrap';
import { DragDropMultiDirectionComponent } from 'src/app/component/shared/drag-drop-multi-direction/drag-drop-multi-direction.component';
import { LatestNewsSectionComponent } from 'src/app/component/latest-news-section/latest-news-section.component';
import { LatestNewsFormComponent } from 'src/app/component/latest-news-section/latest-news-form/latest-news-form.component';

@NgModule({
  declarations: [
    PageEditorComponent,
    AdminLayoutComponent,
    FrontPageComponent,
    EventsComponent,
    MenuEditorComponent,
    AffiliateComponent,
    EventsFormComponent,
    AffiliatesFormComponent,
    ProfileComponent,
    DragDropMultiDirectionComponent,
    LatestNewsSectionComponent,
    LatestNewsFormComponent
  ],
  imports: [
    CommonModule,
    AdminRoutingModule,
    FontAwesomeModule,
    NgxEditorModule,
    ReactiveFormsModule,
    DragDropModule,
    ToastrModule.forRoot(),
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbTimepickerModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AdminModule {}
